import { render } from "./ListItemSkeleton.vue?vue&type=template&id=536aea12&scoped=true"
import script from "./ListItemSkeleton.vue?vue&type=script&lang=js"
export * from "./ListItemSkeleton.vue?vue&type=script&lang=js"

import "./ListItemSkeleton.vue?vue&type=style&index=0&id=536aea12&lang=scss&scoped=true"

import exportComponent from "/home/blissfulapps/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-536aea12"]])

export default __exports__